import styled from 'styled-components';
import colors from 'theme/colors';

export const BreederAdminsTableStyled = styled.section`
  .breeder-admins-table {
    .ant-table-expanded-row > td {
      padding-left: 3.0625rem;
      background-color: ${colors.white};

      .breeder-admins-expandable-table {
        .ant-table-thead > tr > th {
          background: ${colors.darkestGray};
        }
      }
      .ant-table-tbody > tr > td {
        background: ${colors.darkGray};
      }
    }
  }
`;
